module.exports = __webpack_public_path__ + "img/pdf-brander-3.0a7643b2.png";